import styled from 'styled-components';

export const StravaLink = styled.a`
  display: inline-block;
  width: 24rem;
  margin: 4rem 0 8rem;

  &:hover {
    img {
      transform: scale(1.05);
    }
  }

  img {
    width: 100%;
    transition: transform 0.2s ease-out;
  }
`;
